var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:("refs-input-text-input_" + _vm.id),staticClass:"bb-dynamic-input bb-dynamic-input bb-input bb-input_border",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.changeInput($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94481ab2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/DynamicInput/DynamicInput.vue
// module id = null
// module chunks = 